import VersioningState from '../types/VersioningState'

export const state: VersioningState = {
  version: null,
  readyToUpdate: false,
  ui: false,
  modal: false
}
